import React from 'react';
import { ExceedConstrain } from '@moda/om';
import { DesignerListingPageFragment } from '../../generated/types';
import { StickUnderNav } from '../StickUnderNav';
import { ProductListingMobileFilter } from '../ProductListing/ProductListingMobile/ProductListingMobileFilter';
import { PLPBreadcrumbs } from '../PLPBreadcrumbs';
import { Loading } from '../Loading';

import './DesignerListingMobile.scss';

interface Props {
  headerText: string;
  queryResult?: DesignerListingPageFragment | null;
  children?: React.ReactNode;
}

export const DesignerListingMobile: React.FC<Props> = ({ headerText, queryResult, children }) => {
  const count = queryResult?.designers?.length || 0;

  return (
    <div className="DesignerListingMobile">
      <PLPBreadcrumbs />
      <div className="DesignerListingMobile__header">
        <h1 className="DesignerListingMobile__title">{headerText}</h1>
        <div className="DesignerListingMobile__count">
          {count} Designer{count > 1 && 's'}
        </div>
      </div>

      {!queryResult ? (
        <Loading />
      ) : (
        <>
          <StickUnderNav className="DesignerListingMobile__actions-wrapper">
            <ExceedConstrain className="DesignerListingMobile__actions">
              <ProductListingMobileFilter
                queryResult={{ ...queryResult, designers: [] }}
                showPriceFilter={false}
                showCounts={false}
              />
            </ExceedConstrain>
          </StickUnderNav>
          {children}
        </>
      )}
    </div>
  );
};
